import {
  SET_THREAD_CHAT_SCREEN,
  SET_THREAD_CHATS,
  SET_THREAD_ESG_COMPLIANCE_ID,
  SET_THREAD_FILTER,
  SET_THREAD_ID,
  SET_THREAD_MEMBERS,
  SET_THREAD_SUBMISSION_DATA,
} from "constants/thread/threadConst";
import apiBolerplate from "utils/_helpers/apiBolerplate";
import { getEsgComplianceTaskAssignedMetrics } from "../task/esgCompliance/esgComplianceTaskAction";

// ----------------- Payloads -----------------
export function setThreadID(payload) {
  return {
    type: SET_THREAD_ID,
    payload: payload,
  };
}

export function setThreadEsgComplianceId(payload) {
  return {
    type: SET_THREAD_ESG_COMPLIANCE_ID,
    payload: payload,
  };
}

export function setThreadMembers(payload) {
  console.warn("check members");
  return {
    type: SET_THREAD_MEMBERS,
    payload: payload,
  };
}

export function setThreadChats(payload) {
  return {
    type: SET_THREAD_CHATS,
    payload: payload,
  };
}

export function setThreadFilter(payload) {
  return {
    type: SET_THREAD_FILTER,
    payload: payload,
  };
}

export function setThreadChatScreen(payload) {
  return {
    type: SET_THREAD_CHAT_SCREEN,
    payload: payload,
  };
}

export function setThreadSubmissionData(payload) {
  return {
    type: SET_THREAD_SUBMISSION_DATA,
    payload: payload,
  };
}

export function setThreadNotification(payload) {
  return {
    type: "SET_THREAD_NOTIFICATION",
    payload: payload,
  };
}

export function setUserTyping(payload) {
  
  return {
    type: "SET_USER_TYPING",
    payload: payload,
  };
}

export function setUserStopTyping(payload) {
  
  return {
    type: "SET_USER_STOP_TYPING",
    payload: payload,
  };
}

// threadAction.js

export const updateMessageDelivery = ({ thread_id, updates }) => ({
  type: "UPDATE_MESSAGES_DELIVERY",
  payload: { thread_id, updates },
});

export const setOnlineUsers = (user_ids) => ({
  type: "SET_ONLINE_USERS",
  payload: user_ids,
});

// ----------------- Actions -----------------
// For sending text/file type messages
export function sendThreadMsg({ assessment_id, question_id, message, file }) {
  return async (dispatch) => {
    let url = window.origin;
  let domain_name = window.location.hostname;
    apiBolerplate({
      dispatch,
      url: "/esg_compliance_chat/send_message",
      bodyData: { assessment_id, question_id, message,url,domain_name},
      files: file,
      hideLoader: file ? false : true,
      hideMsg: true,
      callback: (data) => {
        // final actions
      },
    });
  };
}

export function getNotification() {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/esg_compliance_chat/get_notification",
      bodyData: {},
      hideMsg: true,
      method: "get",
      callback: (data) => {
        // final actions
        dispatch(setThreadNotification(data?.result));
      },
    });
  };
}

export function clearNotification({ threadId, type }) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/esg_compliance_chat/clear_notification",
      bodyData: { threadId, type },
      hideMsg: true,
      callback: (data) => {
        // final actions
      },
    });
  };
}

export function addNewThreadMsg({ newMsg }) {
  return (dispatch, getState) => {
    const { thread_id } = getState().thread || {};

    // Early validation - O(1)
    if (newMsg?.thread_id !== thread_id) {
      return;
    }

    const newMsgId = newMsg._id.toString();

    // 🚀 PURE O(1) OPERATION - Use SET_THREAD_CHATS with append=false
    dispatch({
      type: "SET_THREAD_CHATS",
      payload: {
        messageById: {
          [newMsgId]: newMsg, // Single new message
        },
        orderedIds: [newMsgId], // Single new ID
        append: false, // 🔥 PREPEND: [newId, ...existingIds]
      },
    });
  };
}

export const fetchThreadChatHistoryPaginated = async ({
  assessment_id,
  question_id,
  cursor = null,
  limit = 20,
}) => {
  const res = await apiBolerplate({
    url: "/esg_compliance_chat/view_chat_history",
    bodyData: { assessment_id, question_id, ...(cursor && { cursor }), limit },
    hideLoader: true,
    hideMsg: true,
  });

  return {
    messageById: res?.messageById || {},
    orderedIds: res?.orderedIds || [],
    nextCursor: res?.nextCursor || null,
    hasMore: res?.hasMore || false,
    members: res?.members || [],
  };
};

export function getThreadRecordedData({ recorded_id }) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/esg_compliance/view_recorded_data",
      bodyData: { recorded_id },
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setThreadSubmissionData(data?.result));
      },
    });
  };
}

export function getThreadSubmissionData({
  submission_type,
  recorded_id,
  submission_id,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/esg_compliance_new/task/view_submission",
      bodyData: { submission_type, recorded_id, submission_id },
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setThreadSubmissionData(data?.result));
      },
    });
  };
}

export function approveThreadSubmission({
  esg_compliance_id,
  metric_id,
  submission_id,
  comment,
  file,
  status,
  handleClose,
  invalidateTaskData,
  user_id,
}) {
  return async (dispatch) => {
    let url = window.origin;
  let domain_name = window.location.hostname;
    apiBolerplate({
      dispatch,
      url: "/esg_compliance_new/task/approve_data",
      bodyData: {
        assessment_id: esg_compliance_id,
        question_id: metric_id,
        submission_id,
        comment,
        status,
        user_id,
        url,
        domain_name
      },
      files: file,
      messageType: status === "Approved" ? "success" : "info",
      customMessage:
        status === "Approved"
          ? "This Submission has been approved"
          : "This Submission has been Rejected",
      callback: (data) => {
        // final actions
        if (Boolean(handleClose)) {
          handleClose();
        }
        dispatch(setThreadChatScreen(null));
        // dispatch(getThreadChatHistory({ esg_compliance_id, metric_id }));
        invalidateTaskData();

        // getEsgComplianceTaskAssignedMetrics({
        //   esg_compliance_id: esg_compliance_id,
        //   framework_id: framework_id,
        //   assigned_as: "APPROVER",
        //   starting_after: 0,
        //   limit: 500,
        // });
      },
    });
  };
}

// ---------------- Supplier Admin ------------------

export function getThreadChatHistoryForSupplierAdmin({
  question_id,
  frequency_id,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/survey_questions/chat/view_chat_history",
      bodyData: { question_id, frequency_id },
      hideLoader: true,
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setThreadChats(data?.result));
      },
    });
  };
}

export function sendThreadMsgForSupplierAdmin({
  question_id,
  frequency_id,
  message,
  file,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/survey_questions/chat/send_message",
      bodyData: { question_id, frequency_id, message },
      files: file,
      hideLoader: file ? false : true,
      hideMsg: true,
      callback: (data) => {
        // final actions
      },
    });
  };
}

export function getSupplierAdminThreadSubmissionData({
  question_id,
  frequency_id,
  submission_id,
  shared_to_org_id,
  survey_id,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url: "/survey_questions/get_submitted_answer",
      bodyData: {
        question_id,
        frequency_id,
        submission_id,
        shared_to_org_id,
        survey_id,
      },
      hideMsg: true,
      callback: (data) => {
        // final actions
        dispatch(setThreadSubmissionData(data?.result));
      },
    });
  };
}

export function approveOrRejectSupplierAdminThreadSubmission({
  submission_id,
  submitted_question_id,
  actionType,
  survey_id,
  frequency_id,
  getSupplierAssignedQuestionsForApproval,
}) {
  return async (dispatch) => {
    apiBolerplate({
      dispatch,
      url:
        actionType === "Approve"
          ? "/survey_questions/approver_answer"
          : "/survey_questions/reject_answer",
      bodyData: {
        submission_id,
        submitted_question_id,
      },
      messageType: "success",
      callback: (data) => {
        dispatch(
          getSupplierAssignedQuestionsForApproval({ survey_id, frequency_id })
        );
      },
    });
  };
}
